/* global google */
/* global ol */

var styleSaturated = {};
var styleDesaturated = {
  stylers: [{ saturation: -80 }]
};

var options = {
  backgroundColor: '#f8fafb',
  clickableIcons: false,
  disableDefaultUI: true,
  disableDoubleClickZoom: true,
  gestureHandling: 'none',
  keyboardShortcuts: false,
  scrollwheel: false,
  styles: [styleDesaturated]
};

var hiddenFeatures = [
  'poi.attraction',
  'poi.business',
  // 'poi.government',
  // 'poi.medical',
  // 'poi.place_of_worship',
  'poi.school',
  'poi.sports_complex',
  'transit.station.bus'
];

function GoogleMapsLayer(map) {
  var openLayersElement = map.getTargetElement();

  this.view = map.getView();

  options.maxZoom = this.view.getMaxZoom();
  options.minZoom = this.view.getMinZoom();
  options.styles = [].concat(options.styles, this.hideFeatures());

  this.googleMaps = new google.maps.Map(document.getElementById('googleMaps'), options);

  if(openLayersElement){
    openLayersElement.parentNode.removeChild(openLayersElement);
  }

  this.googleMaps.controls[google.maps.ControlPosition.TOP_LEFT].push(openLayersElement);

  this.view.on('change:resolution', this.syncZoom.bind(this));
  this.view.on('change:center', this.syncCenter.bind(this));
  map.on('change:size', this.syncSize.bind(this));
}

GoogleMapsLayer.prototype.hideFeatures = function() {
  return hiddenFeatures.map(function(featureType) {
    return {
      featureType: featureType,
      stylers: [{ visibility: 'off' }]
    };
  });
};

GoogleMapsLayer.prototype.syncCenter = function() {
  var center = this.view.getCenter();

  center = ol.proj.transform(center, 'EPSG:3857', 'EPSG:4326');
  center = new google.maps.LatLng(center[1], center[0]);

  this.googleMaps.setCenter(center);
};

GoogleMapsLayer.prototype.syncZoom = function() {
  this.googleMaps.setZoom(this.view.getZoom());
};

GoogleMapsLayer.prototype.syncSize = function() {
  google.maps.event.trigger(this.googleMaps, 'resize');
  this.syncCenter();
};

GoogleMapsLayer.prototype.toggleSaturation = function(saturated) {
  options.styles[0] = saturated ? styleSaturated : styleDesaturated;
  this.googleMaps.setOptions(options);
};

module.exports = GoogleMapsLayer;



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/lib/map/googleMapsLayer.js
 ** module id = 179
 ** module chunks = 1
 **/